/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const MESSAGES = {
  ORGANIZATION_NAME_INFO: "Company name, such as Panasonic Corporation, used for display purposes.",
};

export const TITLE = {
  SAVE: "Save",
  CANCEL: "Cancel",
  ADD_ORGANIZATION: "Add Organization",
  EDIT_ORGANIZATION: "Edit Organization",
  ORGANIZATION_NAME: "Organization Name",
};
